import { buildPageName, PAGE_DEFAULTS, TRACKING_EVENTS } from '@features/page/config/tracking.config'
import { usePageFlow } from '@features/page/context/page-flow-context'
import { trackEvent } from '@shared/lib/tracking'
import { Box, FlexBox, Link, PipeSeparator, Typography } from '@vp/swan'
import { useIdentity } from '@vp/ubik-context'
import { useTranslation } from 'react-i18next'

interface ContactDetailsAuthBarProps {
  isSignedIn: boolean
  profileEmail: string
  displayName: string
}

export const ContactDetailsAuthBar = ({ isSignedIn, profileEmail, displayName }: ContactDetailsAuthBarProps) => {
  const { t } = useTranslation()
  const { signIn, signOut } = useIdentity()
  const { currentStepIndex } = usePageFlow()

  const handleChangeUser = () => {
    signOut()
  }

  const handleSignIn = () => {
    trackEvent(TRACKING_EVENTS.SIGN_IN_FLOW_INITIATED, {
      category: PAGE_DEFAULTS.CATEGORY,
      pageName: buildPageName(currentStepIndex),
    })
    signIn()
  }

  if (isSignedIn) {
    return (
      <FlexBox alignItems="center" gap={4} mb={7}>
        <Typography color="subtle" data-testid="contact-details-profile-email">
          {profileEmail}
        </Typography>
        <PipeSeparator style={{ height: 27 }} />
        <Link data-testid="contact-details-logout-link" onClick={handleChangeUser}>
          {t('contact_us.page.steps.details.actions.logout', { firstName: displayName })}
        </Link>
      </FlexBox>
    )
  }

  return (
    <Box mb={7}>
      <Link data-testid="contact-details-login-link" onClick={handleSignIn}>
        {t('contact_us.page.steps.details.actions.login')}
      </Link>
    </Box>
  )
}
